import { render, staticRenderFns } from "./dodel-typeahead.vue?vue&type=template&id=8f7a5c90&scoped=true&"
import script from "./dodel-typeahead.vue?vue&type=script&lang=js&"
export * from "./dodel-typeahead.vue?vue&type=script&lang=js&"
import style0 from "./dodel-typeahead.vue?vue&type=style&index=0&id=8f7a5c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7a5c90",
  null
  
)

export default component.exports